
import type { PropType, Ref } from 'vue'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: Object as PropType<Ref<string | null>>,
            default: false,
        },
        options: {
            type: Object as PropType<Ref<Array<any>>>,
            required: true
        },
        placeholder: {
            type: String,
            default: null
        },
    },
    emits: ['input', 'option-clicked'],
    setup(props, { emit }) {
        const onInput = (event: Event) => {
            emit('input', event)
        }

        const onOptionClicked = (option: any) => {
            emit('option-clicked', option)
        }

        return {
            onInput,
            onOptionClicked
        }
    }
})
